import Vue from "vue";
import dateFormat from "../utils/dateFormat";

export default Vue.filter("dateFormat", dateFormat);
